import { Button, Modal, ModalProps } from '@payaca/ambrosia';
import { FC } from 'react';

interface IProps extends Omit<ModalProps, 'title'> {
  isProcessing?: boolean;
  onConfirm?: () => void;
}

const ConfirmDeleteNoteModal: FC<IProps> = (props) => {
  const { isOpen, onClose, onConfirm, isProcessing = false, ...rest } = props;

  return (
    <Modal isOpen={isOpen} title="Delete Note" onClose={onClose} {...rest}>
      <Modal.Body>
        <p>Are you sure you want to delete this Note?</p>
      </Modal.Body>

      <Modal.Footer>
        <Modal.Footer.Actions>
          <Button
            isProcessing={isProcessing}
            onClick={() => {
              onConfirm?.();
            }}
            colour={'red'}
          >
            Delete
          </Button>
        </Modal.Footer.Actions>
      </Modal.Footer>
    </Modal>
  );
};
export default ConfirmDeleteNoteModal;
